// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RaXOu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 2px solid #fff;\n  border-radius: 8px;\n  padding: 3px 12px 6px;\n}\n\n.wgOzI {\n  margin: var(--spacing-sm) 0;\n}\n\n.ChTNA {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  border-right: 1px solid #fff;\n  padding-right: var(--spacing-md);\n  margin-right: var(--spacing-sm);\n}\n\n.deN-T {\n  color: #fff;\n}\n\n.pxoQ9 {\n  margin-right: 6px;\n}\n\n.pxoQ9 svg {\n    fill: #fff;\n  }\n\n@media screen and (max-width: 1020px) {\n  .lycTT {\n    max-width: 80px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .pxoQ9 {\n    display: none;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedItem": "RaXOu",
	"mobile": "wgOzI",
	"selectionDetail": "ChTNA",
	"arrow": "deN-T",
	"icon": "pxoQ9",
	"maxWidthText": "lycTT"
};
export default ___CSS_LOADER_EXPORT___;
